/**
 * Configuración e inicialización de Firebase
 * Servicio centralizado para Firebase Auth y otras funcionalidades
 */

import { initializeApp, type FirebaseApp } from 'firebase/app';
import { getAuth, type Auth } from 'firebase/auth';
import { getFirestore, type Firestore } from 'firebase/firestore';
import { getAnalytics, type Analytics } from 'firebase/analytics';
import { env } from '@/shared/config/env';

/**
 * Configuración de Firebase
 */
const firebaseConfig = {
  apiKey: env.VITE_FIREBASE_API_KEY,
  authDomain: env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: env.VITE_FIREBASE_APP_ID,
  measurementId: env.VITE_FIREBASE_MEASUREMENT_ID,
};

/**
 * Inicializar Firebase App
 */
let app: FirebaseApp;
let auth: Auth;
let db: Firestore;
let analytics: Analytics | null = null;

try {
  app = initializeApp(firebaseConfig);
  auth = getAuth(app);
  db = getFirestore(app);

  // Inicializar Analytics solo en producción y si measurementId está disponible
  if (env.VITE_FIREBASE_MEASUREMENT_ID && typeof window !== 'undefined') {
    try {
      analytics = getAnalytics(app);
    } catch (error) {
      // Analytics puede fallar en desarrollo, no es crítico
      console.warn('Firebase Analytics no disponible:', error);
    }
  }
} catch (error) {
  throw new Error(`Error al inicializar Firebase: ${error instanceof Error ? error.message : 'Error desconocido'}`);
}

export { app, auth, db, analytics };
export default app;

